<template>
<div class="chapter">
<div class="inner_page">
<a id="p15"></a>
<blockquote>
<p class="left "><em>God bless the thoughtful islands</em><br/>
        <em>Where never warrants come;</em><br/>
<em>God bless the just Republics</em><br/>
        <em>That give a man a home . . .</em></p>
</blockquote>
<blockquote>
<p class="center "><span class="smallcaps">—RUDYARD KIPLING,</span> “The Broken Men”</p>
</blockquote>
<div class="timebreak "> </div>
<blockquote>
<p class="left ">                <em>Come, my friends,</em><br/>
<em>’Tis not too late to seek a newer world.</em><br/>
<em>Push off, and sitting well in order smite</em><br/>
<em>The sounding furrows, for my purpose holds</em><br/>
<em>To sail beyond the sunset, and the baths</em><br/>
<em>Of all the western stars, until I die.</em><br/>
<em>It may be that the gulfs will wash us down;</em><br/>
<em>It may be we shall touch the Happy Isles . . .</em></p>
</blockquote>
<blockquote>
<p class="center "><span class="smallcaps">—TENNYSON,</span> “Ulysses”</p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front04.vue?30b9d150